export default __webpack_public_path__ + "static/media/avatar.8753d24d.svg";